import { gql } from 'apollo-angular';

export const MUTATION_DELETE_WARRANTY_CERTIFICATE = gql`
  mutation deleteWarrantyCertificate($id: String!) {
    deleteWarrantyCertificate(id: $id) {
      id
      deleted
    }
  }
`;
